import { makeStyles } from "@material-ui/core";

const useDataGridStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: theme.darkGray,
    color: theme.white,
    borderRadius: "0 !important"
  },
  row: {
    height:50
  },
  content: {
    borderRadius: "0 !important"
  }

}));

export default useDataGridStyles;
